// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "block-3LmyJ";
var _3 = "title-6rHXh";
export { _1 as "__esModule", _2 as "block", _3 as "title" }
export default { "__esModule": _1, "block": _2, "title": _3 }
